import { CatalogMetadata } from "./catalog-metadata.model";
import { CatalogScope } from "./catalog-scope.enum";

export class PipesCatalog {
  public constructor(init?: Partial<PipesCatalog>) {
    Object.assign(this, init);
    this.metadata = init && init.metadata ? new CatalogMetadata(init.metadata) : null;
  }

  id: string;
  driftDiameter: number;
  insideDiameter: number;
  outsideDiameter: number;
  wallThickness: number;
  weightPerFoot: number;
  discriminator: string;
  isLocked: boolean;
  metadata: CatalogMetadata;
  scope: CatalogScope;
}

export class PipesCatalogUi {
  public constructor(init?: Partial<PipesCatalogUi>) {
    this.selectedOd = init && init.selectedOd || null;
    this.selectedType = init && init.selectedType || 'tubularPipe';
  }
  selectedOd: string;
  selectedType: string;
}
